import React from "react"

import * as championshipDetailsStyles from "../../styles/world_championships/ChampionshipDetails.module.css"

import { ChildSelector } from "../../helpers/ChildSelector"

export default function ChampionshipDetails(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `championship-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const description = ChildSelector.select(
    content,
    `championship-description`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const feature1Title = ChildSelector.select(
    content,
    `championship-feature-1-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const feature1Icon = ChildSelector.select(
    content,
    `championship-feature-1-icon`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const feature2Title = ChildSelector.select(
    content,
    `championship-feature-2-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const feature2Icon = ChildSelector.select(
    content,
    `championship-feature-2-icon`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const feature3Title = ChildSelector.select(
    content,
    `championship-feature-3-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const feature3Icon = ChildSelector.select(
    content,
    `championship-feature-3-icon`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const callToAction = ChildSelector.select(
    content,
    `championship-cta`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  
  return (
    <section 
      id="championship-details" 
      className={`${championshipDetailsStyles.championshipSection} ${props.className || ''}`}
    >
      <div className={championshipDetailsStyles.container}>
        <div className={championshipDetailsStyles.card}>
          {title && (
            <h3 
              className={championshipDetailsStyles.title}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
          {description && (
            <p 
              className={championshipDetailsStyles.description}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
          <div className={championshipDetailsStyles.features}>
            {feature1Title && (
              <div className={championshipDetailsStyles.featureCard}>
                <div className={championshipDetailsStyles.featureIcon}>
                  {feature1Icon || "💥"}
                </div>
                <h4 className={championshipDetailsStyles.featureTitle}>
                  {feature1Title}
                </h4>
              </div>
            )}
            {feature2Title && (
              <div className={championshipDetailsStyles.featureCard}>
                <div className={championshipDetailsStyles.featureIcon}>
                  {feature2Icon || "💥"}
                </div>
                <h4 className={championshipDetailsStyles.featureTitle}>
                  {feature2Title}
                </h4>
              </div>
            )}
            {feature3Title && (
              <div className={championshipDetailsStyles.featureCard}>
                <div className={championshipDetailsStyles.featureIcon}>
                  {feature3Icon || "💥"}
                </div>
                <h4 className={championshipDetailsStyles.featureTitle}>
                  {feature3Title}
                </h4>
              </div>
            )}
          </div>
          {callToAction && (
            <p 
              className={championshipDetailsStyles.callToAction}
              dangerouslySetInnerHTML={{ __html: callToAction }}
            />
          )}
        </div>
      </div>
    </section>
  )
}
